module.exports = ".text-bold{font-weight:bold}";